import { createEntityQuery } from '../../createEntityQuery';
import {
  DisbursementSharedService,
  type Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementDetailDto,
} from '@wealthlane/api-services/wealthlane-award-settlement-service';

export type DisbursementDetailDto =
  Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementDetailDto;

const useDisbursementDetailsQuery = createEntityQuery<DisbursementDetailDto, string>({
  queryKey: ['disbursementDetails'],
  queryFn: (transactionId) =>
    DisbursementSharedService.getApiAwardSettlementApiAppDisbursementDisbursementDetail(
      transactionId!,
    ),
  silent: true,
});

/**
 * Disbursement detail by transaction ID.
 * Shared across award types (Options, SAR, etc.).
 * SAR transaction tab: pass `intentTransactionId ?? transactionId` as the effective ID.
 */
export function useGetDisbursementDetails(
  transactionId: string | undefined,
  enabled = true,
) {
  return useDisbursementDetailsQuery(transactionId as string, {
    enabled: Boolean(transactionId) && enabled,
  });
}
